import {
  AiOutlineNotification,
  AiOutlineCalendar,
  AiOutlineGift,
  AiOutlineShoppingCart,
  AiOutlineFunnelPlot,
  AiOutlineTag,
  AiFillFileImage,
} from "react-icons/ai"
import { BsKanban } from "react-icons/bs"
import { FiEdit, FiShoppingBag } from "react-icons/fi"
import { IoMdContacts } from "react-icons/io"
import { RiContactsLine } from "react-icons/ri"

/* -------------------------
   ADMIN MENU (FULL)
-------------------------- */
export const adminLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "overview",
        icon: <FiShoppingBag />,
      },
    ],
  },
  {
    title: "Pages",
    links: [
      {
        name: "bookings",
        icon: <AiOutlineShoppingCart />,
      },
      {
        name: "employees",
        icon: <IoMdContacts />,
      },
      {
        name: "customers",
        icon: <RiContactsLine />,
      },
      {
        name: "marketing",
        icon: <AiOutlineNotification />,
      },
      {
        name: "services",
        icon: <AiOutlineFunnelPlot />,
      },
    ],
  },
  {
    title: "Apps",
    links: [
      {
        name: "calendar",
        icon: <AiOutlineCalendar />,
      },
      {
        name: "workflow",
        icon: <BsKanban />,
      },
      {
        name: "invoice",
        icon: <FiEdit />,
      },
      {
        name: "discount",
        icon: <AiOutlineGift />,
      },
      {
        name: "offers",
        icon: <AiOutlineTag />,
      },
      {
        name: "media",
        icon: <AiFillFileImage />,
      },
    ],
  },
]

/* -------------------------
   MANAGER MENU (LIMITED)
-------------------------- */
export const managerLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "overview",
        icon: <FiShoppingBag />,
      },
    ],
  },
  {
    title: "Pages",
    links: [
      {
        name: "bookings",
        icon: <AiOutlineShoppingCart />,
      },
    ],
  },
  {
    title: "Apps",
    links: [
      {
        name: "calendar",
        icon: <AiOutlineCalendar />,
      },
    ],
  },
]
export const shopManagerLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "overview",
        icon: <FiShoppingBag />,
      },
    ],
  },
  {
    title: "Apps",
    links: [
      {
        name: "calendar",
        icon: <AiOutlineCalendar />,
      },
    ],
  },
]
